class MainBlog extends HTMLElement {
    constructor() {
        super();

        this.mainBlog = this.querySelector("[js-main-blog]");
        this.init();
    }

    init() {
        this.paginationItem = this.querySelectorAll("[js-pagination-item]");
        this.paginationItem.forEach( pagination => pagination.addEventListener("click", this.renderBlog.bind(this)));
    }
    renderBlog(evt) {
        evt.preventDefault();

        const { currentTarget } = evt;
        const isTag = currentTarget.classList.contains("pagination__item");

        const href = currentTarget.getAttribute("href");
        const url = isTag ? `${href}&section_id=${this.mainBlog.getAttribute('data-section-id')}` : `${href}&section_id=${this.mainBlog.getAttribute('data-section-id')}`;

        this.updateLoading(true);
        this.updateScroll();
        this.updateURLHash(href);
        this.renderSectionFromFetch(url);
    }

    updateLoading(isLoading) {
        isLoading ? this.mainBlog.classList.add("loading") : this.mainBlog.classList.remove("loading");
    }

    updateScroll() {
        const bannerHeight = document.querySelector(".hb_blogs_banner").getBoundingClientRect().height;
        const scrollHeight = bannerHeight + 32;
        
        window.scrollTo({top: scrollHeight, behavior: 'smooth'});
    }

    updateURLHash(url) {
        history.pushState({ url }, '', url);
    }

    renderSectionFromFetch(url) {
        fetch(url)
        .then((response) => response.text())
        .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            this.mainBlog.innerHTML = doc.querySelector("[js-main-blog]").innerHTML;
            this.init();
        })
        .finally(() => {
            this.updateLoading(false);
        })
    }
}
  
customElements.define('hb-main-blog', MainBlog);

